<template>
<v-card :flat='flat' >
  <v-card-title class='overline pb-0' >
    Medical Aid details
  </v-card-title>
  <v-list three-line >
    <v-list-tile >
      <v-list-tile-content>
        <v-list-tile-title>{{ value.name || 'scheme unknown' }}</v-list-tile-title>
        <v-list-tile-sub-title class="text--primary" >
          {{ value.patient_first_name }} {{ value.patient_last_name}}
        </v-list-tile-sub-title>
        <v-list-tile-sub-title ># {{ value.number || 'no membership number' }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-if="value.is_dependent === true" >
      <v-list-tile-content>
        <v-list-tile-title>Main member</v-list-tile-title>
        <v-list-tile-sub-title class="text--primary">{{ value.member_first_name }} {{ value.member_last_name }}</v-list-tile-sub-title>
        <v-list-tile-sub-title >
          ID: {{ value.main_member_id_number || 'unknown' }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</v-card>
</template>
<script>
export default {
  name: 'MedicalAidCard',
  props: {
    value: { required: true, type: Object },
    flat: { type: Boolean, default: true }
  }
}
</script>



// WEBPACK FOOTER //
// MedicalAidCard.vue?ee49474e